export default function Pagination({ nPages, currentPage, setCurrentPage, totalRecords, indexOfFirstRecord, indexOfLastRecord }) {

    const nextPage = () => {
        if(currentPage === nPages){
            setCurrentPage(currentPage)
        }else{
            setCurrentPage(currentPage + 1)
        }
    }

    const prevPage = () => {
        if(currentPage === 1){
            setCurrentPage(currentPage)
        }else{
            setCurrentPage(currentPage - 1)
        }
    }

    return (
      <nav
        className="flex items-center justify-between border-t border-gray-200 bg-primarioMira px-4 py-5 sm:px-6 rounded-b-lg"
        aria-label="Pagination"
      >
        <div className="hidden sm:block">
          <p className="text-sm text-white">
            Mostrando <span className="font-medium">{indexOfFirstRecord + 1}</span> hasta <span className="font-medium">{currentPage === nPages ? totalRecords : indexOfLastRecord}</span> de
            <span className="font-medium"> {totalRecords} </span> resultados
          </p>
        </div>
        <div className="flex flex-1 justify-between sm:justify-end  h-10">
          <button
            type="button"
            className="relative inline-flex items-center rounded-md border border-transparent bg-secundario px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-secundario hover:border-2"
            onClick={() => prevPage()}
          >
            Atrás
          </button>
          <button
            type="button"
            className="relative ml-3 inline-flex items-center rounded-md border border-transparent bg-secundario px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-secundario hover:border-2"
            onClick={() => nextPage()}
          >
            Siguiente
          </button>
        </div>
      </nav>
    )
  }
  

/*import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'

export default function Pagination({ nPages, currentPage, setCurrentPage, totalRecords, indexOfFirstRecord, indexOfLastRecord }) {
    
    console.log(nPages)
    const pageNumbers = [...Array(nPages - 20).keys()].slice(1)

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="flex flex-1 justify-between sm:hidden">
        <a
          href="#"
          className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Previous
        </a>
        <a
          href="#"
          className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Next
        </a>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{indexOfFirstRecord + 1}</span> a <span className="font-medium">{indexOfLastRecord}</span> de
            <span className="font-medium"> {totalRecords}</span> resultados
          </p>
        </div>
        <div>
          <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
            <a
              href="#"
              className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </a>
            
            {
                pageNumbers.map((pgNumber => {
                    return(
                        <a
                        href="#"
                        aria-current="page"
                        className="relative z-10 inline-flex items-center border border-indigo-500 bg-indigo-50 px-4 py-2 text-sm font-medium text-indigo-600 focus:z-20"
                        >
                            {pgNumber}
                        </a>
                    )
                }))
            }
            <a
              href="#"
              className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </a>
          </nav>
        </div>
      </div>
    </div>
  )
}*/
